import { createEntityAdapter } from '@reduxjs/toolkit';

import { createReferenceAdapter } from '../../base/adapters';
import type {
  DelayResponse,
  DelayResponseReference,
  Function,
  FunctionParameter,
  FunctionReference,
} from './function.schema';

export const delayResponsesAdapter = createEntityAdapter<DelayResponse>();

export const parametersAdapter = createEntityAdapter<FunctionParameter>();

export const functionsAdapter = createEntityAdapter<Function>();

const references: FunctionReference[] = [
  'topics',
  'flowSteps',
  'behaviour',
  'stopKeywords',
  'variables',
];

const delayResponseReferences: DelayResponseReference[] = ['variables'];

export const functionsReferencesAdapter = createReferenceAdapter(references);

export const delayResponseReferencesAdapter = createReferenceAdapter(
  delayResponseReferences,
);
